<svg class="diag-graphe-v2-emissions" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 189 223.5">
    <defs>
        <style>
            .diag-graphe-v2-emissions .a {
                fill: #a4dbf8;
            }

            .diag-graphe-v2-emissions .b {
                fill: #8cb4d3;
            }

            .diag-graphe-v2-emissions .c {
                fill: #7792b1;
            }

            .diag-graphe-v2-emissions .d {
                fill: #606f8f;
            }

            .diag-graphe-v2-emissions .e {
                fill: #4d5271;
            }

            .diag-graphe-v2-emissions .f {
                fill: #393551;
            }

            .diag-graphe-v2-emissions .g {
                fill: #281b35;
            }

            .diag-graphe-v2-emissions .cadre {
                fill: none;
                stroke: #a5dbf8;
                stroke-miterlimit: 10;
                stroke-width: 1.42px;
            }

            .diag-graphe-v2-emissions .line-black {
                fill: none;
                stroke: #1d1d1b;
                stroke-width: 0.99px;
            }

            .diag-graphe-v2-emissions .value {
                fill: #1d1d1b;
            }

            .diag-graphe-v2-emissions .white {
                fill: #fff;
            }
        </style>
    </defs>

    <title>Gaz à effet de serre</title>

    <!-- Général -->
    <rect class="cadre" x="14.72" y="24.14" width="156.02" height="170" rx="5.67"/>
    <g transform="translate(25,40)" font-size="10" font-weight="bold" fill="#1d1d1b">
        <text x="0" y="0">Dont émissions de gaz</text>
        <text x="0" y="10">à effet de serre</text>
    </g>

    <!-- A -->
    <text x="25" y="68" font-size="7" font-weight="bold" fill="#8cb4d3">
        peu d’émissions de CO<tspan dy="3">²</tspan>
    </text>
    <path class="a" d="M25.35,83.63H43.28a5.27,5.27,0,0,0,5.28-5.28h0a5.27,5.27,0,0,0-5.28-5.27H25.35Z"/>
    <path class="white" d="M32.62,81.5,32.17,80h-2.1l-.45,1.5H28.23l2.07-6.29H32L34,81.5Zm-1.49-5h0l-.7,2.38h1.44Z"/>

    <!-- B -->
    <path class="b" d="M25.35,95.67h26.3a5.27,5.27,0,0,0,5.28-5.28h0a5.28,5.28,0,0,0-5.28-5.28H25.35Z"/>
    <path class="white"
          d="M28.58,87.25h3.05a1.52,1.52,0,0,1,1.66,1.61c0,1-.53,1.33-1.17,1.35v.06a1.38,1.38,0,0,1,1.41,1.47,1.69,1.69,0,0,1-1.62,1.79H28.58ZM30,89.83h1.36a.54.54,0,0,0,.58-.58V89a.54.54,0,0,0-.58-.58H30Zm0,2.55h1.58a.52.52,0,0,0,.58-.57v-.3a.53.53,0,0,0-.58-.57H30Z"/>

    <!-- C -->
    <path class="c" d="M25.35,107.71h34.4A5.28,5.28,0,0,0,65,102.43h0a5.29,5.29,0,0,0-5.28-5.28H25.35Z"/>
    <path class="white"
          d="M28.65,102.48c0-2.13,1.09-3.3,2.79-3.3a2.33,2.33,0,0,1,2.35,1.48l-1.18.61a1.12,1.12,0,0,0-1.17-.87c-.8,0-1.34.54-1.34,1.53v1c0,1,.54,1.53,1.34,1.53a1.3,1.3,0,0,0,1.25-.94l1.11.65a2.44,2.44,0,0,1-2.36,1.5C29.74,105.68,28.65,104.6,28.65,102.48Z"/>

    <!-- D -->
    <path class="d" d="M25.84,129.1V109.69H65.6a9.71,9.71,0,1,1,0,19.41Z"/>
    <path class="white"
          d="M30.05,126.2a.5.5,0,0,1-.5-.49V113.14a.51.51,0,0,1,.5-.5h4.74c3.77,0,6,2.54,6,6.78s-2.25,6.78-6,6.78Zm4.74-3.42c1.45,0,2.13-.76,2.13-2.38v-2c0-1.62-.68-2.38-2.13-2.38H33.28v6.71Z"/>

    <!-- E -->
    <path class="e" d="M25.35,141.64H83.24a5.27,5.27,0,0,0,5.27-5.28h0a5.28,5.28,0,0,0-5.27-5.28H25.35Z"/>
    <path class="white" d="M29.1,139.5v-6.28h4.27v1.21H30.46v1.29H33v1.21h-2.5v1.36h2.91v1.21Z"/>

    <!-- F -->
    <path class="f" d="M25.35,153.68H91.46a5.29,5.29,0,0,0,5.28-5.28h0a5.28,5.28,0,0,0-5.28-5.28H25.35Z"/>
    <path class="white" d="M29.2,151.54v-6.28h4.16v1.21h-2.8v1.29H33V149H30.56v2.57Z"/>

    <!-- G -->
    <path class="g" d="M25.35,165.72H99.77a5.29,5.29,0,0,0,5.28-5.28h0a5.28,5.28,0,0,0-5.28-5.28H25.35Z"/>
    <path class="white"
          d="M32.58,162.58h0c-.09.63-.66,1.11-1.61,1.11-1.44,0-2.57-1.12-2.57-3.23s1.14-3.27,2.84-3.27a2.49,2.49,0,0,1,2.42,1.46l-1.11.63a1.31,1.31,0,0,0-1.31-.88c-.84,0-1.39.49-1.39,1.53v1c0,1.05.55,1.53,1.39,1.53.69,0,1.24-.32,1.24-.93v-.32H31.26v-1.14h2.47v3.5H32.58Z"/>
    <g transform="translate(25,175)" font-size="7" font-weight="bold" fill="#281b35">
        <text x="0" y="0">émissions de CO<tspan dy="3">²</tspan></text>
        <text x="0" y="8">très importantes</text>
    </g>

    <!-- Lignes données -->
    <line class="line-black" x1="77.83" y1="119.42" x2="99.09" y2="119.42"/>
    <path class="value"
          d="M65.6,110.18a9.22,9.22,0,0,1,0,18.43H26.33V110.18H65.6m0-1H25.34V129.6H65.6a10.21,10.21,0,0,0,0-20.41Z"/>
    <path class="value"
          d="M34.79,113.14c3.33,0,5.52,2.11,5.52,6.28s-2.19,6.29-5.52,6.29H30.05V113.14h4.74m-2,10.14h2c1.62,0,2.62-.88,2.62-2.88v-2c0-2-1-2.88-2.62-2.88h-2v7.71m2-11.13H30.05a1,1,0,0,0-1,1v12.57a1,1,0,0,0,1,1h4.74c4.08,0,6.52-2.72,6.52-7.28s-2.44-7.27-6.52-7.27Zm-1,4.41h1c.85,0,1.63.23,1.63,1.89v2c0,1.66-.78,1.89-1.63,1.89h-1v-5.73Z"/>

    <!-- Données -->
    <g *ngIf="emissions >= 0" transform="translate(100,124)" font-weight="bold">
        <text x="0" y="0" font-size="16" >
            {{emissions}} <tspan *ngIf="emissions < 1000" font-size="5">kg
            CO<tspan dy="2">²</tspan><tspan dy="-2px">/m²/an</tspan></tspan>
        </text>
        <text *ngIf="emissions >= 1000" x="2" y="7" font-size="5">
            kg CO<tspan dy="2">²</tspan><tspan dy="-2px">/m²/an</tspan>
        </text>
    </g>
</svg>
